import React, { ReactElement } from 'react';

const ReviewComplete = (): ReactElement => (
  <div className="review--complete-layout">
    <div className="review--complete-layout--container">
      <div>
        <img
          alt="ELMO Logo"
          className="review--complete-layout--container--logo"
          src="https://elmocoursebuilder.com.au/images/ELMO_Logo.png"
        />
      </div>
      <div className="review--complete-layout--container--body">
        <div className="review--complete-layout--container--body--message">
          This course review has already been completed.
        </div>
      </div>
      <div className="review--complete-layout--container--text">
        Powered by ELMO Software
      </div>
    </div>
  </div>
);

export default ReviewComplete;
